import { useContext } from 'react';
import { UiLogicModules } from '../../../../infrastructure/types/models/UiLogicModules';
import { UILogicContext } from './context';

function useUILogic(): UiLogicModules {
  return useContext(UILogicContext);
}

export { useUILogic };
